import React from "react"
import {
  find,
} from 'lodash'
import {
  Checkbox,
  Button,
  Table,
} from "semantic-ui-react"
import InvoicesTableSmartInvoiceSelector from './InvoicesTableSmartInvoiceSelector'

const InvoicesTable = (logic) => {
  const {
    invoicesPopupFilteredInvoices = [],
    selectedInvoices = [],
    onInvoiceCheckboxPress = () => { },
    onMatchSelectedInvoicesPress = () => { },
    selectedBankTransfer = {},
    invoicesSortConfig = {},
    onInvoicesSort = () => { },
  } = logic

  return (
    <div>
      <InvoicesTableSmartInvoiceSelector {...logic} />
      <Table
        sortable
        celled
        selectable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              Select
              {selectedInvoices.length ? `(${selectedInvoices.length})` : ''}
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={invoicesSortConfig.key === 'orderNumber' 
                ? (invoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') 
                : null}
              onClick={() => onInvoicesSort('orderNumber')}
            >
              Invoice Code
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={invoicesSortConfig.key === 'enterpriseCode' ? (invoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
              onClick={() => onInvoicesSort('enterpriseCode')}
            >
              Enterprise Code
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={invoicesSortConfig.key === 'paymentDueDate' ? (invoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
              onClick={() => onInvoicesSort('paymentDueDate')}
            >
              Payment Due Date
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={invoicesSortConfig.key === 'invoiceAmountString' ? (invoicesSortConfig.direction === 'asc' ? 'ascending' : 'descending') : null}
              onClick={() => onInvoicesSort('invoiceAmountString')}
            >
              Invoice Amount
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {invoicesPopupFilteredInvoices.map((invoice) => {
            const {
              orderNumber = '',
              enterpriseCode = '',
              paymentDueDate = '',
              invoiceAmountString = '',
            } = invoice

            return (
              <Table.Row
                key={orderNumber}
                active={selectedInvoices.includes(orderNumber)}
              >
                <Table.Cell>
                  <Checkbox
                    checked={!!find(selectedInvoices, { orderNumber })}
                    onChange={() => onInvoiceCheckboxPress(invoice)}
                  />
                </Table.Cell>
                <Table.Cell>{orderNumber}</Table.Cell>
                <Table.Cell>{enterpriseCode}</Table.Cell>
                <Table.Cell>{paymentDueDate}</Table.Cell>
                <Table.Cell>{invoiceAmountString}</Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
    </div>
  )
}

export default InvoicesTable
